import axios from 'axios'
import u from '@/utils'

const fetchBots = async filter => {
  let url = `/api/v1/bots`
  if (filter) {
    url = url + filter + '&projection=withMetrics'
  }
  return await axios.get(url)
}

const deleteBot = async botHexId => {
  await axios.delete(`/api/v1/bots/${botHexId}`)
}

const fetchBotIdentities = async bot => {
  const response = await axios.get(`/api/v1/bots/${bot.hexId}/identities`)
  let identities = [...response.data._embedded.identities]
  identities = identities.map(identity => u.processResp(identity))
  return identities
}

const addIdentitiesToBot = async (identities, bot) => {
  let data = identities
    .map(identity => {
      return `/api/v1/identites/${identity.hexId}`
    })
    .join('\n')
  await axios.post(`/api/v1/bots/${bot.hexId}/identities`, data, {
    headers: {
      'Content-Type': 'text/uri-list'
    }
  })
}

const deleteIdentitiesFromBot = async (identity, bot) => {
  await axios.delete(`/api/v1/bots/${bot.hexId}/identities/${identity.hexId}`)
}

export default {
  fetchBots,
  deleteBot,
  fetchBotIdentities,
  addIdentitiesToBot,
  deleteIdentitiesFromBot
}
